import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=cea66b44&scoped=true&"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=cea66b44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea66b44",
  null
  
)

export default component.exports